import React from 'react';

const Badge = ({ children, bgColor = 'success', color = 'label' }) => {
  return (
    <div className={`count-badge background-${bgColor}`}>
      <span className={`f-12 fw-700 text-${color}`}>{children}</span>
    </div>
  );
};

export default Badge;
